import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
	getProcedureHistoryListQuery as getProcedureHistoryListQueryAPI,
	addProcedureHistory as addProcedureHistoryAPI,
	getProcedureHistory as getProcedureHistoryAPI,
	updateProcedureHistory as updateProcedureHistoryAPI,
	deleteProcedureHistory as deleteProcedureHistoryAPI,
} from '../../helpers/procedure_history/api_helper';

export const getProcedureHistoryListQuery = createAsyncThunk(
	'procedureHistory/getProcedureHistoryListQuery',
	async (params, { rejectWithValue }) => {
		try {
			const response = await getProcedureHistoryListQueryAPI(params);
			return response;
		} catch (error) {
			toast.error('Error al obtener la lista de historial de trámites', { autoClose: 2000 });
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);

export const addProcedureHistoryThunk = createAsyncThunk(
	'procedureHistory/addProcedureHistory',
	async (data, { rejectWithValue }) => {
		try {
			const response = await addProcedureHistoryAPI(data);
			toast.success('Historial de trámite creado correctamente', { autoClose: 2000 });
			return response;
		} catch (error) {
			toast.error('Error al crear el historial de trámite', { autoClose: 2000 });
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);

export const getProcedureHistoryThunk = createAsyncThunk(
	'procedureHistory/getProcedureHistory',
	async (id, { rejectWithValue }) => {
		try {
			const response = await getProcedureHistoryAPI(id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el historial de trámite', { autoClose: 2000 });
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);

export const updateProcedureHistoryThunk = createAsyncThunk(
	'procedureHistory/updateProcedureHistory',
	async ({ id, data }, { rejectWithValue }) => {
		try {
			const response = await updateProcedureHistoryAPI(id, data);
			toast.success('Historial de trámite actualizado correctamente', { autoClose: 2000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar el historial de trámite', { autoClose: 2000 });
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);

export const deleteProcedureHistoryThunk = createAsyncThunk(
	'procedureHistory/deleteProcedureHistory',
	async (id, { rejectWithValue }) => {
		try {
			const response = await deleteProcedureHistoryAPI(id);
			toast.success('Historial de trámite eliminado correctamente', { autoClose: 2000 });
			return response;
		} catch (error) {
			toast.error('Error al eliminar el historial de trámite', { autoClose: 2000 });
			return rejectWithValue(error.response?.data || error.message);
		}
	}
);
